import { PermissionBit, SeerlinqStudyTextResponse } from "../../../api";
import { resolveEnumLabel } from "../../../components/ui-kit/fields/utils";
import { monitoringTypes } from "../../../constants/enum-to-text";
import { AccessRules } from "../../../constants/roles";
import { localeLabel } from "../../../languages";
import { DataModel } from "../../../models/data-model";

export type StudyTextsItem = SeerlinqStudyTextResponse & {
  monitoringTypeText: string;
  languageText: string;
  clinicName: string;
  physicianName: string;
};

export class StudyTexts extends DataModel<StudyTextsItem> {
  readonly idAttr = "uuid" as keyof StudyTextsItem;

  constructor(
    data: StudyTextsItem[],
    permissions: PermissionBit[],
    userUUID?: string,
  ) {
    super(data, permissions, userUUID);

    this.access = {
      editRules: { medical: AccessRules.none, monitoring: AccessRules.none },
      deleteRules: { medical: AccessRules.none, monitoring: AccessRules.none },
      historyRequiresMonitoring: false,
    };
  }
}

export function toStudyTextsItem(
  item: SeerlinqStudyTextResponse,
): StudyTextsItem {
  return {
    ...item,
    monitoringTypeText:
      resolveEnumLabel(monitoringTypes[item.monitoring_type]) ||
      String(item.monitoring_type),
    languageText: localeLabel(item.study_text_language),
    clinicName: item.clinic?.name ?? "",
    physicianName: item.physician
      ? `${item.physician.given_name} ${item.physician.family_name}`
      : "",
  };
}
